module.exports = __webpack_public_path__ + "img/paypal.46e2f779.svg";